module.exports = __webpack_public_path__ + "static/media/MK.6f9700e3.png";